import { HLJ_STATISTIC } from '../tool'

// 统计屏幕信息
export const statScreen = () => {
  const { width, height } = window.screen
  HLJ_STATISTIC({
    ext: {
      size: `${width}*${height}`
    },
    event_type: 'element_view'
  })
}
